<template>
  <div class="inicio-detalhes-modal">
    <h4 class="text-center mb-3">{{ titulo }}</h4>

    <div v-if="carregando" class="text-center text-muted p-4">
      <span class="spinner-border spinner-border-sm mr-2" role="status"></span>
      Carregando registros...
    </div>

    <div v-else-if="itens.length === 0" class="alert alert-light text-center">
      Nenhum registro encontrado.
    </div>

    <div v-else>
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>Código</th>
              <th>{{ tipo === 'projeto' ? 'Projeto' : 'Atividade' }}</th>
              <th>Situação</th>
              <th class="text-center">Período</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in itensPaginados"
              :key="idItem(item)"
              class="clickable"
              @click="$emit('selecionar', item)"
            >
              <td>{{ item.codigo || '-' }}</td>
              <td class="coluna-titulo">
                <el-tooltip
                  :content="item.titulo"
                  placement="top"
                  :disabled="!item.titulo || item.titulo.length <= 80"
                >
                  <strong>{{ tituloResumido(item.titulo) }}</strong>
                </el-tooltip>
              </td>
              <td :class="classeSituacao(item)">{{ item.situacaoDescricao || item.situacao }}</td>
              <td
                class="text-center periodo-detalhe"
                :class="{ 'periodo-atrasado': registroAtrasado(item) }"
              >
                <i class="far fa-calendar-alt mr-1"></i>
                {{ item.dataInicio }} a {{ item.dataFim }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="itens.length > itensPorPagina" class="paginacao-detalhes">
        <b-pagination
          v-model="paginaAtual"
          :total-rows="itens.length"
          :per-page="itensPorPagina"
          first-number
          last-number
          size="sm"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InicioDetalhesModal",
  props: {
    titulo: { type: String, required: true },
    tipo: { type: String, required: true },
    itens: { type: Array, default: () => [] },
    carregando: { type: Boolean, default: false },
  },
  data() {
    return {
      paginaAtual: 1,
      itensPorPagina: 15,
    };
  },
  computed: {
    itensPaginados() {
      const inicio = (this.paginaAtual - 1) * this.itensPorPagina;
      return this.itens.slice(inicio, inicio + this.itensPorPagina);
    },
  },
  watch: {
    itens() {
      this.paginaAtual = 1;
    },
  },
  methods: {
    idItem(item) {
      return this.tipo === "projeto" ? item.idprojeto : item.idatividade;
    },
    classeSituacao(item) {
      return "font-" + item.situacao;
    },
    registroAtrasado(item) {
      const situacao = (item.situacao || item.situacaoDescricao || "").toUpperCase();
      return situacao === "ATRASADO" || situacao === "ATRASADA";
    },
    tituloResumido(titulo) {
      const valor = (titulo || "").trim();
      return valor.length > 80 ? `${valor.substring(0, 80)}...` : valor;
    },
  },
};
</script>

<style scoped>
.inicio-detalhes-modal {
  padding: 12px 18px 18px;
}
.inicio-detalhes-modal tbody tr {
  font-size: 13px;
}

.coluna-titulo {
  width: 100%;
}

.periodo-detalhe {
  white-space: nowrap;
}

.periodo-atrasado {
  color: #b821bd;
  font-weight: 600;
}

.paginacao-detalhes {
  display: flex;
  justify-content: center;
  padding-top: 8px;
}

.paginacao-detalhes ul {
  margin-bottom: 0;
}
</style>

<style>
@media (min-width: 992px) {
  .modal-dialog.modal-detalhes-inicio {
    width: calc(100% - 60px);
    max-width: 1100px;
  }
}
</style>
